import { TTRTimeFilterType } from '../index'
import { ThisConnector } from '../../../api/connector'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { Query } from '../../../hooks/queries'

interface VulnerabilityTTRArgs {
  organizationUuid: string
}
export interface TTRPropertiesResponse {
  vulnerabilityTTRTimeFilterType: TTRTimeFilterType
}

export async function getVulnerabilityTTRProperties(
  this: ThisConnector,
  { organizationUuid }: VulnerabilityTTRArgs
) {
  return this.connector.get<TTRPropertiesResponse>(
    `organizations/${organizationUuid}/ttr/properties`
  )
}

export const useGetVulnerabilityTTRProperties = ({
  organizationUuid
}: VulnerabilityTTRArgs) => {
  const { isLoading, data, error, isError } = useContrastQuery<
    VulnerabilityTTRArgs,
    TTRPropertiesResponse
  >(
    [Query.VULNERABILITY_TTR_PROPERTIES, organizationUuid],
    getVulnerabilityTTRProperties,
    { organizationUuid }
  )

  return {
    isLoading,
    data,
    isError,
    error
  }
}
